interface AppliedCheckItem {
  comment?: { type?: string | null } | null;
  option?: { id?: number | null } | null;
  value?: string | null;
}

const isCommentApplied = (item?: AppliedCheckItem | null): boolean => {
  const type = item?.comment?.type;
  if (type === 'checkbox') return item?.value === '1';
  if (type === 'select') return !!item?.option && item.option.id !== -1;
  return !!item?.value && item.value !== '0';
};

export default isCommentApplied;
